import { render } from "./Auditorio.vue?vue&type=template&id=78dc939a&scoped=true"
import script from "./Auditorio.vue?vue&type=script&lang=js"
export * from "./Auditorio.vue?vue&type=script&lang=js"

import "./Auditorio.vue?vue&type=style&index=0&id=78dc939a&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78dc939a"]])

export default __exports__